import { Observable, of } from "rxjs";
import { switchMap, mergeMap, map, withLatestFrom, filter, catchError } from "rxjs/operators";
import { fromFetch } from "rxjs/fetch";
import { Location } from "./location";
import { Geocoder } from "./geocoder";
export class Infra3dGeocoder extends Geocoder {
    _id;
    _locations = {};
    constructor(inputField, config_opt) {
        super(inputField);
        const newConf = config_opt || {};
        this.configure(newConf);
        this._id = "0";
    }
    get query$() {
        return this.inputSearch$(300).pipe(withLatestFrom(this.configuration$), filter(([searchTerm, configuration]) => {
            if (configuration.datasets.indexOf("mistra") != -1 && configuration.mistra) {
                if (searchTerm.indexOf(" KM ") != -1)
                    return false;
            }
            return true;
        }), switchMap(([searchTerm, configuration]) => {
            return fromFetch(this._url(searchTerm, configuration), {
                headers: {
                    Accept: "application/json",
                    "x-api-key": configuration.apiKey,
                },
                credentials: "omit",
            }).pipe(mergeMap((response) => {
                return response.json();
            }), map((json) => {
                const res = [];
                this._id = "0";
                for (const pos of json.positions) {
                    this._id = (parseInt(this._id) + 1).toString();
                    const _geopos = Location.createFromInfra3dGeocoder(this._id, pos);
                    res.push(_geopos);
                    this._locations[this._id] = _geopos;
                }
                return res;
            }), catchError(() => {
                console.error("Infra3dGeocoder: error fetching or parsing data.");
                return of({ positions: [] });
            }));
        }));
    }
    select(locationId) {
        return new Promise((resolve, reject) => {
            if (this._locations[locationId]) {
                resolve(this._locations[locationId]);
            }
            else {
                reject(Error("no location found for the given id"));
            }
        });
    }
    _url(q, config) {
        const geocoders_list = config.datasets.filter((x) => x != "mistra" && x != "metadb");
        const url_adds = [];
        if (config.datasets.indexOf("mistra") != -1 && config.mistra) {
            geocoders_list.push("mistra");
            url_adds.push(`referencedate=${config.mistra.referencedate}`);
        }
        if (config.datasets.indexOf("metadb") != -1 && config.metadb) {
            geocoders_list.push("metadb");
            url_adds.push(`dbname=${config.metadb.dbname}`);
            url_adds.push(`dbschema=${config.metadb.dbschema || "public"}`);
        }
        const geocoders = geocoders_list.map((x) => `geocoder=${x}`).join("&");
        let url = `${config.host}?query=${encodeURIComponent(q)}&${geocoders}&outsrid=4326&page=1&start=0&limit=10`;
        if (url_adds.length > 0) {
            url = `${url}&${url_adds.join("&")}`;
        }
        return url;
    }
    _getDefaultConfiguration() {
        return {
            name: "infra3dgeocoder",
            host: "https://api.infra3d.com/geocoder/",
            datasets: ["nominatim", "lrefsearch_rhb2017"],
            apiKey: "",
        };
    }
}
//# sourceMappingURL=infra3dgeocoder.js.map